module.exports = __webpack_public_path__ + "static/media/angle-left.ff79b99d.svg";